module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"simulators":"Simulateurs","administration":"Administration","log-out":"Me déconnecter","documentation":"Documentation"},"en":{"simulators":"Simulators","administration":"Administration","log-out":"Log out","documentation":"Documentation"}}')
  delete Component.options._Ctor
}
